import { render, staticRenderFns } from "./HistoryAct.vue?vue&type=template&id=0c9e83ee&"
import script from "./HistoryAct.vue?vue&type=script&lang=js&"
export * from "./HistoryAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports